import { getTableViewByType } from './table-view';

export function FactBottomComponent($compile) {
  return {
    restrict  : 'AE',
    scope     : {
      filter   : '=',
      fact     : '=',
      showImage: '=',
    },
    controller: function ($scope, $element, $sce) {
      $scope.trustAsHtml = $sce.trustAsHtml;
      let setHeight = function () {
        $element.height($element.parent().height() - 10);
      };
      $scope.$on('resize', setHeight);
      $scope.$on('splitterChanged', setHeight);

    },
    link      : function (scope, element, attrs) {
      scope.$watch('fact', function (newVal, oldVal) {
        if (!scope.filter) return;
        let fact = newVal ? newVal : {};
        scope.textData = fact ? fact['text_data'] : '';
        scope.event_id = fact ? fact['id'] : 0;
        let viewMode = getTableViewByType(fact['agent_eventtype.id']);
        let widget = viewMode.important.map(colView => {
          let data = colView.parse(fact, 'extended');
          let label = ( data && colView.label ) ? '<span class="label">' + colView.label + ':</span> ' : '';
          return label + data + ( (label + data) ? '<br/>' : '');
        }).join('', '');
        element.html(widget);
        $compile(element.contents())(scope);
      });
    },
  };
}



// WEBPACK FOOTER //
// ./src/facts/fact-bottom.component.js